const projectitems = [
  {
    title: 'Sync Sofa',
    subtitle: 'remote streaming video synchronizer',
    overall: 'Led an open-source full-stack project to synchronize streaming video playback with multiple remote users from scratch, iterated 10 versions, and maintained 6k active users on Google Web Store with over 90% positive feedback.',
    points: [
      'Built REST APIs using Golang to handle the lifecycle of connection sessions and broadcast video playback through WebSocket.',
      'Implemented a mutual handshake and heartbeat mechanism on the client-side to ensure stable and low latency sync within 1 second.',
      'Developed built-in video call and text messaging features using webRTC and self-developed signaling server in Golang.',
    ],
  },
  {
    title: 'Pet diet Formulator',
    subtitle: 'full-stack pet diet recommendation webapp',
    overall: 'Designed and developed a full-stack web app to recommend optimal pet diet plans based on the nutritional needs of the pets.',
    points: [
      'Used Hibernate to manage schema models and build high-performance REST APIs with JWT based user authentication.',
      'Abstracted the services layer with delegation design pattern and Java reflection to improve the extendibility and readability.',
      'Prototyped and developed interactive, maintainable, and promise based web client using React, Axios, and Redux.',
    ],
  },
  {
    title: 'Course Channels',
    subtitle: 'full-stack student group-chat web app',
    overall: 'Developed a slack-like chat web application with an API gateway-based microservice architecture.',
    points: [
      'Developed a self-implemented API gateway to perform IAM, SSL termination, session management, and Websocket connections.',
      'Created a messaging microservice that exposes REST APIs for CRUD operations of messages and channels using node.js.',
      'Developed a real-time notifications infrastructure to listen and relay message events over RabbitMQ and WebSocket.',
      'Implemented a trie data structure to index usernames for the autocomplete search suggestions feature.',
    ],
  },
  {
    title: 'Database management system',
    overall: 'Implemented a relational database management system with transaction, recovery, and buffer management. And achieved top-tier query performance in course lab tests on IMDB datasets.',
    points: [
      'Developed select, join, group by and aggerate operators by implementing the query tree generation and execution process.',
      'Implemented a thread-safe, two-phase locking-based concurrency control to ensure isolation and atomicity of transactions.',
      'Optimized query operations with B+ tree indexing and statistical query cost estimation algorithm.',
    ],
  },
];

export default projectitems;
